export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="pt-32 pb-20 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="animate-slide-up">
            <h1 className="text-5xl lg:text-6xl font-bold text-sprintwise-dark leading-tight mb-6" data-testid="hero-title">
              Мы создаём <span className="gradient-text">лучшие IT-решения</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-testid="hero-subtitle">
              Мы занимаемся продуктовой разработкой и создаём качественные цифровые продукты на базе современных технологий
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => scrollToSection('contact')} 
                className="bg-gradient-to-r from-sprintwise-primary to-sprintwise-secondary text-white px-8 py-4 rounded-xl font-semibold hover:shadow-xl hover:scale-105 transition-all duration-300 text-center"
                data-testid="button-discuss-project"
              >
                Обсудить проект
              </button>
              <button 
                onClick={() => scrollToSection('cases')} 
                className="border border-gray-300 text-gray-700 px-8 py-4 rounded-xl font-semibold hover:border-sprintwise-primary hover:text-sprintwise-primary transition-all duration-300 text-center"
                data-testid="button-view-cases"
              >
                Смотреть кейсы
              </button>
            </div>
          </div>
          
          <div className="relative animate-float">
            <img 
              src="/images/hero-team.jpg" 
              alt="Команда разработчиков за работой" 
              className="rounded-2xl shadow-2xl w-full h-auto" 
              data-testid="hero-team-image"
            />
            
            {/* Floating Elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 tech-card rounded-2xl flex items-center justify-center animate-pulse-slow">
              <svg className="w-8 h-8 text-sprintwise-primary" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2L2 7v10c0 5.55 3.84 9.739 9 11 5.16-1.261 9-5.45 9-11V7l-10-5z"/>
              </svg>
            </div>
            
            <div className="absolute -bottom-6 -left-6 w-32 h-20 tech-card rounded-2xl flex items-center justify-center animate-pulse-slow" style={{animationDelay: '1s'}}>
              <div className="text-center">
                <div className="text-2xl font-bold text-sprintwise-primary" data-testid="stat-projects">100+</div>
                <div className="text-xs text-gray-600">Проектов</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Background decoration */}
      <div className="absolute top-1/2 left-1/4 w-32 h-32 bg-gradient-to-r from-sprintwise-primary/10 to-sprintwise-secondary/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 right-1/4 w-48 h-48 bg-gradient-to-r from-sprintwise-accent/10 to-sprintwise-primary/10 rounded-full blur-3xl"></div>
    </section>
  );
}
